
const timeZoneOffset = new Date().getTimezoneOffset() * 60

export function fullDateConverter (timestamp) {
  var time = new Date((timestamp - timeZoneOffset) * 1000)
  return time.toISOString().slice(0, -5)
} // 2019-12-04T02:00:00

export function dateConverter (timestamp) {
  return fullDateConverter(timestamp).split('T')[0]
} // 2019-12-04

export function timeConverter (timestamp) {
  return fullDateConverter(timestamp).split('T')[1].slice(0, -3)
} // 02:00:00

export function minConverter (timestamp) {
  return fullDateConverter(timestamp).split('T')[1].slice(0, -3)
} // 20:00

export function dateAndTimeConverter (timestamp) {
  var date = dateConverter(timestamp)
  var time = timeConverter(timestamp)
  return date.slice(5) + ' ' + time
} // 12-04 02:00

export function mounthAndDayConverter (timestamp) {
  var date = dateConverter(timestamp)
  return date.slice(5)
} // 12-04

export function weekDayConverter (timestamp) {
  var time = new Date((timestamp - timeZoneOffset) * 1000)
  return time.getDay()
}

export function secondsToTime (e) {
  var h = Math.floor(e / 3600).toString().padStart(2, '0')
  var m = Math.floor(e % 3600 / 60).toString().padStart(2, '0')
  var s = Math.floor(e % 60).toString().padStart(2, '0')
  return h + ':' + m + ':' + s
}

export function secondsToMin (e) {
  var m = Math.floor(e / 60).toString().padStart(2, '0')
  var s = Math.floor(e % 60).toString().padStart(2, '0')
  return m + ':' + s
}

// itemCallback : (item) => label: String
export function groupItems (items, itemCallback) {
  let sourceList = items
  let labelMapList = []

  sourceList.forEach((item, index, array) => {
    let label = itemCallback(item)
    let foundItem = labelMapList.filter(item2 => item2['label'] === label)
    if (foundItem.length === 0) {
      labelMapList.push({
        label: label,
        list: [ item ]
      })
    } else {
      foundItem[0].list.push(item)
    }
  })
  return labelMapList
}

export function checkEmptyObject (obj) {
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  const emptyObjectCheck = obj.constructor === Object && Object.keys(obj).length === 0
  if (emptyObjectCheck) {
    return true
  } else {
    const hasValueCheck = x => {
      if (x.constructor === Array) {
        return x.length > 0
      } else if (x.constructor === Number) {
        return x !== 0
      } else {
        return x !== null && x !== ''
      }
    }
    return !Object.values(obj).some(hasValueCheck)
  }
}

export function hexToRGB (hex, alpha) {
  if (typeof hex !== 'string') {
    return null
  }

  // 过滤非法输入
  if (!/^#[0-9ABCDEFabcdef]{1,6}$/.test(hex)) {
    return null
  }

  let pureStr = hex.slice(1)

  // 处理简写形式
  if (pureStr.length === 3) {
    pureStr = [].concat(...[...pureStr].map(v => [v]).map(v => v.concat(v))).join('')
  }

  let result = []

  for (let i = 0; i < pureStr.length; i += 2) {
    result.push(parseInt((pureStr[i] + pureStr[i + 1]), 16))
  }

  return `rgba(${result.join(', ')}, ${alpha})`
}

// 比较版本号
// v1 大于 v2 返回 1    v1 小于 v2 返回 -1   v1 等于 v2 返回 0
export function versionCompare (v1, v2, options) {
  var lexicographical = options && options.lexicographical
  var zeroExtend = options && options.zeroExtend
  var v1parts = v1.split('.')
  var v2parts = v2.split('.')

  function isValidPart (x) {
    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x)
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN
  }

  if (zeroExtend) {
    while (v1parts.length < v2parts.length) v1parts.push('0')
    while (v2parts.length < v1parts.length) v2parts.push('0')
  }

  if (!lexicographical) {
    v1parts = v1parts.map(Number)
    v2parts = v2parts.map(Number)
  }

  for (var i = 0; i < v1parts.length; ++i) {
    if (v2parts.length === i) {
      return 1
    }

    if (v1parts[i] === v2parts[i]) {
      continue
    } else if (v1parts[i] > v2parts[i]) {
      return 1
    } else {
      return -1
    }
  }

  if (v1parts.length !== v2parts.length) {
    return -1
  }
  return 0
}
